<div class="operational-system-container" *ngIf="!isLoadingLabels && !isLoadingOperationalSystems">
	<div *ngIf="operationalSystemInterface.id == undefined">
		<cpi-msp-table
			[header]="searchHeader"
			[body]="operationalSystemsList"
			[searchable]="true"
			[height]="'55dvh'"
			[itemPadding]="'1%'"
			[labels]="labels"
			[insideSort]="true"
			(getSelectedItem)="openForm($event[0])">
		</cpi-msp-table>

		<div class="button-container">
			<div class="button" (click)="clearInputs(true)">{{ labels.lbl_geral_novo }}</div>
		</div>
	</div>

	<ng-container *ngIf="operationalSystemInterface.id != undefined">
		<div class="header-wrap">
			<span class="tab selected">Sistema Operacional</span>
		</div>
		<div class="body-wrap">
			<div class="search-container">
				<div class="form-container">
					<div class="dotted-input-container">
						<span>Tipo de CI*</span>
						<select id="type" name="type" [(ngModel)]="operationalSystemInterface.type">
							<option [value]="''" selected>{{ labels.lbl_geral_selecione }}</option>
							<option *ngFor="let option of ciTypeList" [value]="option.id">{{ option.label }}</option>
						</select>
					</div>

					<div class="dotted-input-container">
						<span>Sistema Operacional*</span>
						<input
							id="operational_system"
							name="operational_system"
							type="text"
							[(ngModel)]="operationalSystemInterface.operational_system" />
					</div>

					<div class="dotted-input-container">
						<span>MS String</span>
						<input id="ms_string" name="ms_string" type="text" [(ngModel)]="operationalSystemInterface.ms_string" />
					</div>
				</div>

				<div class="button-container">
					<div class="button" (click)="clearInputs(false)">{{ labels.lbl_geral_voltar }}</div>
					<div class="button" (click)="clearInputs(true)">{{ labels.lbl_geral_novo }}</div>
					<div
						class="button"
						*ngIf="operationalSystemInterface.id !== ''"
						(click)="deleteOperationalSystem($event)"
						#deleteButton>
						{{ deleteButton.classList.contains('double-click') ? labels.lbl_geral_confirmar : labels.lbl_geral_excluir }}
					</div>
					<div class="button" type="submit" (click)="validateForm()">{{ labels.lbl_geral_salvar }}</div>
				</div>
			</div>
		</div>
	</ng-container>
</div>

<cpi-dot-bounce-loading-effect
	class="mt-2 ml-2"
	*ngIf="isLoadingOperationalSystems || isLoadingLabels"
	[color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
